import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../css/about.css';

const strengths = [
  {
    number: 1,
    title: "Extensive Expertise",
    desc: "Our team brings comprehensive knowledge and experience to every oil and gas project."
  },
  {
    number: 2,
    title: "Adaptable Infrastructure",
    desc: "Our flexible structure enables rapid response to client needs, ensuring smooth project management."
  },
  {
    number: 3,
    title: "Punctual and Secure Execution",
    desc: "Timely and secure project delivery is our top priority, backed by strict safety measures."
  },
  {
    number: 4,
    title: "Global Network",
    desc: "Our vast domestic and international network fosters strong relationships with global stakeholders, allowing efficient resource utilization."
  },
  {
    number: 5,
    title: "Regulatory Compliance",
    desc: "We uphold rigorous regulatory standards in all jurisdictions, ensuring projects adhere to relevant laws and regulations."
  },
];

function Home() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  const underlineRef = useRef(null);


  useEffect(() => {
    const timer = setTimeout(() => {
      if (underlineRef.current) {
        underlineRef.current.classList.add('animate');
      }
    }, 50); // Delay before animation starts

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Section 1: Fullscreen Background */}
      <div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '85vh', padding: 0, top: '-122px', position: 'relative' }}>
        {/* overlay */}
        <div style={{ position: 'absolute' }}></div>
        <div className="container about-content my-5" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row">
            <div className="col-lg-6 col-md-8 col-12 about-text">
              <h1 className="about-title text-white">About Us</h1>
              <h2 className="about-subtitle">Petrochoice Integrated Services</h2>
              <div className="about-underline" ref={underlineRef}></div>
              <p className="about-desc">
                Petrochoice is an internationally renowned corporation that specializes in delivering outstanding services to the oil and gas sector on a global scale. Leveraging our substantial knowledge and robust infrastructure, our unwavering commitment is to consistently achieve excellence across all facets of our operations.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: About Block */}
      <div className="container my-5">
        <div className="row align-items-center">
          <div className="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0" data-aos="fade-up">
            <h2 className="title">About us</h2>
            <div className="rounded overflow-hidden shadow-sm mt-3" style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
              <img
                src="/assets/about us im 01.jpeg"
                alt="Rig Offshore"
                className="img-fluid"
                data-aos="zoom-in"
                data-aos-delay="200"
              />
            </div>
          </div>
          <div className="col-lg-8 col-md-6 col-12 mt-3 mt-md-0" data-aos="fade-left">
            <div className="p-4 p-lg-5 bg-white rounded shadow-sm" style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
              <p className='breif-aboutus mb-0'>
                Whether it’s project commencement or the triumphant conclusion, we guarantee expert management, exacting implementation, and rigorous adherence to safety standards.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3: We Own Know How */}
      <div className="container mt-5">
        <div className="row align-items-center">
          <div className="col-lg-8 col-12 order-2 order-lg-1 px-lg-5 mt-4 mt-lg-0" data-aos="fade-right">
            <h2 className="title">We Own Know How</h2>
            <div className="p-4 p-lg-5 bg-white rounded shadow-sm" style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
              <p className='breif-aboutus mb-0' style={{ textAlign: "justify" }}>
                Welcome to Petrochoice, your trusted partner for comprehensive drilling and production solutions and more in the oil and gas industry.
                Our team of experienced professionals is committed to delivering exceptional consultancy services across all disciplines, including drilling operations, mud and cementing, directional drilling, crew management, engineering, and more.
                At Petrochoice, our vision is to become the global partner of choice for organizations seeking expertise, reliability, and innovation in every phase of their drilling operations
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-12 order-1 order-lg-2" data-aos="fade-left">
            <div className="rounded overflow-hidden shadow-sm" style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
              <img
                src="/assets/own know how.jpg"
                alt="Rig Offshore"
                className="img-fluid"
              />
            </div>
          </div>
        </div>

        <hr className="mt-5" style={{ width: '100%', height: '2px', backgroundColor: '#1769ff', marginTop: '50px' }} />
      </div>

      {/* Section 4: Our Strengths */}
      <div className="container mt-5">
        <h2 className="title mb-4" data-aos="fade-down">Our Strengths:</h2>
        <div className="row">
          {strengths.map((item, index) => (
            <div key={index} className="col-md-6 col-lg-4 mb-4" data-aos="zoom-in" data-aos-delay={index * 150}>
              <div className="h-100 p-4 bg-white rounded shadow-sm" style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
                <div className="d-flex align-items-start mb-2">
                  <div className="me-3 d-flex align-items-center justify-content-center" style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(247,124,0,0.12)', color: '#f57c00', fontWeight: 800 }}>{item.number}</div>
                  <h5 className="fw-bold mb-0" style={{ color: '#0a3161' }}>{item.title}</h5>
                </div>
                <p className="text-muted mb-0" style={{ lineHeight: 1.75, fontSize: 16 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Section 5: Our Commitment */}
      <div className="container-fluid mt-5 section-5" style={{ position: 'relative' }}>
        <div className="container text-white text-center" style={{ position: 'relative', zIndex: 2 }}>
          <h2 className="fw-bold text-white mb-2" data-aos="fade-up">Our Commitment</h2>
          <p className="fst-italic text-warning mb-4" data-aos="fade-up" data-aos-delay="100">
            What you can expect when dealing with Petrochoice
          </p>
          <p className="mb-5 text-white" style={{ maxWidth: "900px", margin: "0 auto", lineHeight: "1.7" }} data-aos="fade-up" data-aos-delay="200">
            Petrochoice is a globally recognized leader in providing exceptional services to the oil and gas industry. Our unwavering commitment to excellence, extensive global resources, and industry expertise make us the preferred choice for companies seeking reliable solutions. Collaborate with us for a truly professional experience.
          </p>

          <div className="row text-start mt-4">
            {/* Items */}
            {[
              {
                icon: "/assets/worker.png",
                title: "Safety Priority",
                desc: "Safety is our foremost concern, encompassing personnel, assets, and the environment. Our robust protocols and proactive risk management ensure a secure work environment."
              },
              {
                icon: "/assets/performance.png",
                title: "Performance Excellence",
                desc: "We are dedicated to delivering top-tier performance through cutting-edge technologies and innovative solutions. Our aim is to enhance efficiency, reduce costs, and optimize project outcomes."
              },
              {
                icon: "/assets/budget-1.png",
                title: "Budget Control",
                desc: "We emphasize strict budget control through meticulous planning, cost oversight, and transparent communication, ensuring projects adhere to budget constraints."
              },
              {
                icon: "/assets/budget.png",
                title: "Client Satisfaction",
                desc: "Our clients are of utmost importance, and we aim to exceed their expectations. We foster strong partnerships, maintain open communication, and provide personalized attention to ensure client delight."
              }
            ].map((item, i) => (
              <div key={i} className="col-lg-3 col-md-6 mb-4" data-aos="fade-up" data-aos-delay={i * 200}>
                <div className="p-4 h-100 rounded" style={{ background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(3px)' }}>
                  <div className="mb-3">
                    <img src={item.icon} alt={item.title} style={{ height: 50 }} />
                  </div>
                  <h5 className="fw-bold text-white" style={{ lineHeight: 2 }}>{item.title}</h5>
                  <p className="text-white-50 mb-0" style={{ lineHeight: 1.8, fontSize: 15 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* subtle overlay for section-5 if background image exists */}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.45) 100%)' }}></div>
      </div>
    </>
  );
}

export default Home;